import ClockoutController from '../../core/clockout.controller';

/**
 * @extends ClockoutController
 */
class SignupSuccessController extends ClockoutController {
    async initialize() {
        // Component initialized
    }

    async cleanup() {
        // Cleanup if needed
    }

    continueToDashboard() {
        this.navigateLogin();
    }

    navigateToSignIn() {
        window.location.href = '/';
    }
}

export default SignupSuccessController;

